module.exports = __webpack_public_path__ + "img/workovertime_remark.6e6363c6.svg";